import React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './Layout.module.css';

const Layout = () => {
    return (
        <div className={styles.container} data-testid="survey-layout">
            <div className={styles.containerWidth}>
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
